module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-dispo",
    attrs: {
      "id": "list-video"
    }
  }, [_c('vue-topprogress', {
    ref: "topProgress",
    staticStyle: {
      "position": "relative",
      "right": "0px",
      "height": "7px"
    }
  }), _vm._v(" "), _c('b-row', [_c('div', {
    staticClass: "modal-body-content-module"
  }, [_c('div', {
    attrs: {
      "id": "plan1"
    }
  }, [_c('b-row', [_c('b-card', {
    attrs: {
      "id": "card-add-prog"
    }
  }, [_c('div', {
    staticClass: "icon-add-prog"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "60",
      "height": "60",
      "viewBox": "0 0 30 30"
    }
  }, [_c('path', {
    attrs: {
      "id": "Color",
      "d": "M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z",
      "transform": "translate(3.75 3.75)",
      "fill": "#acadb1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('module.generic.title')))]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "color": "#68686b"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('module.generic.textAdd')) + " " + _vm._s(_vm.$t('blocks.add_generic_' + _vm.genericType)) + "\n              ")])])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "list_video"
    }
  }, [_c('b-row', [_c('div', {
    staticClass: "search-wrapper-list",
    attrs: {
      "id": "search-list"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-input-group', {
    staticClass: "search-group"
  }, [_c('b-input-group-append', {
    staticClass: " search-icon",
    on: {
      "click": function($event) {
        return _vm.searchVideo(true)
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1.5em",
      "height": "1.5em",
      "viewBox": "0 0 40 40"
    }
  }, [_c('path', {
    attrs: {
      "id": "Color",
      "d": "M28.879,28.929a1.083,1.083,0,0,1-.76-.305l-6.96-6.712v-.072A13.25,13.25,0,0,1,7.772,23.775,12.758,12.758,0,0,1,3.4,20.785,12.074,12.074,0,0,1,3.763,3.629a13.2,13.2,0,0,1,17.791-.352A12.079,12.079,0,0,1,22.648,20.4h.075l6.96,6.712a1.007,1.007,0,0,1-.043,1.507A1.1,1.1,0,0,1,28.879,28.929ZM12.857,2.143A10.468,10.468,0,0,0,2.143,12.321a9.863,9.863,0,0,0,3.138,7.2A10.935,10.935,0,0,0,12.857,22.5a11.15,11.15,0,0,0,4.1-.775,10.724,10.724,0,0,0,3.476-2.206,10.11,10.11,0,0,0,2.322-3.3,9.7,9.7,0,0,0,.815-3.9,9.862,9.862,0,0,0-3.138-7.2A10.934,10.934,0,0,0,12.857,2.143Z",
      "transform": "translate(5 6)",
      "fill": "#7c7c7c"
    }
  })])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "inputSearch",
    attrs: {
      "placeholder": _vm.$t('placeholder.search'),
      "id": "inputSearch"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchVideo(true)
      }
    },
    model: {
      value: (_vm.textToSearch),
      callback: function($$v) {
        _vm.textToSearch = $$v
      },
      expression: "textToSearch"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-module-list",
    attrs: {
      "id": "close-module-list"
    },
    on: {
      "click": function($event) {
        return _vm.searchVideo(false)
      }
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])], 1)], 1), _vm._v(" "), _c('b-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSelect),
      expression: "showSelect"
    }]
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    on: {
      "change": function($event) {
        return _vm.onChangeThemId()
      }
    },
    model: {
      value: (_vm.idSelectedTheme),
      callback: function($$v) {
        _vm.idSelectedTheme = $$v
      },
      expression: "idSelectedTheme"
    }
  }, [_c('template', {
    slot: "first"
  }, _vm._l((this.options), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.title,
        "value": option.id
      }
    }, [_vm._v("\n                        " + _vm._s(option.title) + "\n                      ")])
  }), 0)], 2)], 1)], 1)], 1)]), _vm._v(" "), _c('b-row', {
    staticClass: "list-generics"
  }, [_c('div', {
    staticClass: "list-generic-videos"
  }, _vm._l((_vm.all_video), function(video, index) {
    return _c('div', {
      staticClass: "video-wrapper"
    }, [_c('div', {
      class: [
        'video-tag',
        'video-tag-' + index,
        {
          'is-selected-video': _vm.selected_vid === video.id || (!_vm.selected_vid && _vm.isSelected(video)),
        } ],
      on: {
        "click": function($event) {
          return _vm.SelectVideo(video, index)
        }
      }
    }, [_c('div', {
      staticClass: "image-card"
    }, [_c('div', {
      staticClass: "image-card__video"
    }, [(video.logo) ? _c('img', {
      staticClass: "img-liste-dispo",
      attrs: {
        "src": video.logo,
        "id": video.id
      }
    }) : _c('img', {
      staticClass: "img-liste-dispo",
      attrs: {
        "src": _vm.defaultScreenshot,
        "alt": "alt_img",
        "id": video.id
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: " image-card__infos__duration duration-style",
      attrs: {
        "title": video.duration
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.duration(video.duration)) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: " image-card__infos__title",
      attrs: {
        "title": video.title
      }
    }, [_vm._v("\n                    " + _vm._s(video.title) + "\n                  ")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: " center",
    attrs: {
      "id": "loader-liste-dispo"
    }
  }, [_c('span', [_c('infinite-loading', {
    attrs: {
      "spinner": "bubbles"
    }
  })], 1)])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "position-buttons"
  }, [_c('button', {
    class: ['btn btn-outline-secondary', 'footer-select-button'],
    on: {
      "click": function($event) {
        return _vm.closeGenericList()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.back')) + "\n          ")]), _vm._v(" "), (_vm.genericType === 'fin') ? _c('button', {
    class: ['btn btn-primary', 'footer-select-button'],
    attrs: {
      "disabled": _vm.disabledSelectButton
    },
    on: {
      "click": function($event) {
        return _vm.addGeneriqueVideo()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.select')) + "\n          ")]) : _vm._e()])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0273cd3e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListGenericVideo.vue
// module id = 812
// module chunks = 1 3